import { ViewStream, safeClone } from 'spyne';
import { DesignSystemTraits } from 'traits/_design-systems/design-system-traits.js';
import { HighlightTraits } from 'traits/_design-systems/highlight-traits.js';
import { PageItemCoreTraits} from 'traits/page-item-core-traits.js';
import { HeroView } from 'components/page-items/hero-view.js';

export class PageDesignSystemView extends ViewStream {
  constructor(props = {}) {
    props.class = `page-view page-view-${props?.data?.pageId}`;
    props.channels = [['CHANNEL_ROUTE', true]];
    props.traits = [DesignSystemTraits, HighlightTraits, PageItemCoreTraits];
    props.data = safeClone(props.data);
    props.data.imgUrl = props.data?.img?.imgUrl || props.data.img?.src?.large;
    props.data.__cms__isProxy = true;


    props.template = DesignSystemTraits.designSystem$GetPageTemplate(props.data, props?.isDeepLink);

    super(props);
  }
  addActionListeners() {
    return [['CHANNEL_ROUTE_CHANGE_EVENT', 'disposeViewStream']];
  }

  broadcastEvents(){
    return [

      ['button', 'click'],
      ['a', 'click']
    ]

  }

  onRendered() {
    this.hl$HighlightBlocks();


    const {hero, content} = this.props.data;

    if (hero){
      this.appendView(new HeroView({data: hero}), '.hero-container')
    }

    if (content){

    }



    if (this.props.data.pageItems){
      console.log("THIS HAS ELEMENTS ",this.props);

      this.pageItemCore$AddPageItems(this.props.data.pageItems);
    }

  }
}
